module.exports = __webpack_public_path__ + "static/media/64.48a7e057.jpg";